import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-succes-create-struc',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './succes-create-struc.component.html',
  styleUrl: './succes-create-struc.component.scss'
})
export class SuccesCreateStrucComponent {
  constructor() {
  }

}
